import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { GetResponse } from "@/api/app-name-list/response";
import * as AppNameListAPI from "@/api/app-name-list";
import { isSuccess } from "@/api/response";

const MODULE_NAME = "app-name-list/get";

/**
 * アプリ名情報取得API（/get-app-name-list）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Get extends VuexModule {
  // state
  getResponse: GetResponse = {} as GetResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.getResponse);
  }

  get getMessage() {
    return this.getResponse.message;
  }

  get getItems() {
    if (this.getResponse.results) {
      return this.getResponse.results.items || [];
    } else {
      return [];
    }
  }

  get getTotalCount() {
    if (this.getResponse.results) {
      return (this.getResponse.results.items || []).length;
    } else {
      return 0;
    }
  }

  // MutationActions
  @MutationAction
  async get() {
    const getResponse = await AppNameListAPI.get();
    return {
      getResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      getResponse: {} as GetResponse
    };
  }
}

export default getModule(Get);
